module.exports = __webpack_public_path__ + "img/people.172ce8ec.svg";